import React from 'react';
import HostDetails from '../../components/HostDetails';
import { HOST_DETAILS_PATH } from './constants';

export default {
  path: HOST_DETAILS_PATH,
  render: props => <HostDetails {...props} />,
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/HostDetails/index.js